import { ParkingStatuses } from '@aggregator/core';
import { enumToDescriptedArray } from '@shared/core';
import { FormFieldType, IFormGroupConfig } from '@shared/ui';

export const filterFormConfig: IFormGroupConfig = {
  type: FormFieldType.GROUP,
  fields: {
    searchTerm: {
      type: FormFieldType.INPUT,
      label: 'Название парковки:',
      placeholder: 'Введите название',
    },
    operatorId: {
      type: FormFieldType.SELECT,
      label: 'Оператор:',
      placeholder: 'Укажите оператора',
      optionValueField: 'id',
      optionLabelField: 'name',
      pageable: true,
      paginationType: 'page',
      showSearch: true,
      searchField: 'name',
      requestUrl: 'operators',
    },
    typeId: {
      type: FormFieldType.SELECT,
      label: 'Тип:',
      placeholder: 'Укажите тип',
      optionValueField: 'id',
      optionLabelField: 'name',
      requestUrl: 'parking-types',
    },
    categoryId: {
      type: FormFieldType.SELECT,
      label: 'Категория',
      placeholder: 'Укажите категория',
      optionValueField: 'id',
      optionLabelField: 'name',
      requestUrl: 'categories',
    },
    status: {
      type: FormFieldType.SELECT,
      label: 'Статус:',
      placeholder: 'Укажите статус',
      options: enumToDescriptedArray(ParkingStatuses),
      optionLabelField: 'description',
      optionValueField: 'id',
    },
    isPaid: {
      type: FormFieldType.CHECKBOX,
      label: 'Платная',
    },
  },
};
